import React from 'react';

import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

const list = [
    {
        name: 'х4',
        desc: 'трафика за 6 месяцев работы',
    },
    {
        name: '120',
        desc: 'часов команды SEO',
    },
    {
        name: '20+',
        desc: 'инструментов задействовано',
    },
];

const Ciphers = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} className="mts-invest-ciphers">
                <CommonTitle className="mts-invest-ciphers__title">Цифры</CommonTitle>
                <div className="mts-invest-ciphers__wrapper">
                    <div className="mts-invest-ciphers__grid">
                        {list.map(({ name, desc }, index) => (
                            <ScrollAnimation
                                delay={500}
                                animateIn="fadeIn"
                                offset={0}
                                animateOnce={true}
                                duration={1}
                                className="mts-invest-ciphers__item"
                                key={index}
                            >
                                <div className="mts-invest-ciphers__top">
                                    <div className="mts-invest-ciphers__top-content">
                                        <div className="mts-invest-ciphers__name">{name}</div>
                                        <div className="mts-invest-ciphers__desc">{desc}</div>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Ciphers;
